import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

type IGetMerchantStatusCounts = BaseResponse<{
  activeCount: number;
  passiveCount: number;
  blockedCount: number;
}>;

async function getMerchantStatusCounts(): Promise<IGetMerchantStatusCounts> {
  try {
    const response = await axiosInstance.post("/Merchant/GetMerchantStatusCounts");
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantStatusCounts() {
  return useQuery<IGetMerchantStatusCounts, Error>(
    [QueryKeys.GetMerchantStatusCounts],
    getMerchantStatusCounts
  );
}
